module.exports = __webpack_public_path__ + "static/media/investment-watchlist.cd638b2d.png";